import PropTypes from 'prop-types';
import styled from 'styled-components';
import { MozartModal, MozartButton } from '@pgforsta/mozart_ui/lib/v4';
import ModalWrapper from '../styled/ModalWrapper';
import ButtonGroup from '../styled/ButtonGroup';

const baseUrl = process.env.REACT_APP_SOCIAL_CRAWLER_BASE_URL;

const ConfirmationQuestion = styled.p`
  margin-bottom: 15px;
`;

const Link = styled.a`
  margin-top: 10px;
  display: block;
  color: #598cec;
  font-size: 14px;
  text-decoration: none;
`;

const UrlFinderModal = ({
  show,
  status,
  onClose,
  withConfirmation = false,
  isConfirmed,
  onConfirm,
  clientId,
}) => {
  const renderModalContents = () => {
    if (withConfirmation && !isConfirmed) {
      return (
        <>
          <ConfirmationQuestion>
            Do you want to trigger the URL finder?
          </ConfirmationQuestion>
          <ButtonGroup>
            <MozartButton outline onClick={onClose}>
              No
            </MozartButton>
            <MozartButton onClick={onConfirm}>Yes</MozartButton>
          </ButtonGroup>
        </>
      );
    }

    if (status === 'idle' || status === 'pending') {
      return <p>Loading...</p>;
    }

    if (status === 'rejected') {
      return <p>An error has occurred.</p>;
    }

    const url = `${baseUrl}/search_status${
      Boolean(clientId) ? `?clientId=${clientId}` : ''
    }`;

    return (
      <>
        <p>
          URL finding for the entity is in progress. Please check this URL for
          the status:
        </p>
        <Link href={url} target="_blank" rel="noreferrer noopener">
          {url}
        </Link>
      </>
    );
  };

  return (
    <ModalWrapper>
      <MozartModal show={show} onClose={onClose} title="URL finder Triggered!">
        {renderModalContents()}
      </MozartModal>
    </ModalWrapper>
  );
};

UrlFinderModal.propTypes = {
  show: PropTypes.bool.isRequired,
  status: PropTypes.oneOf(['idle', 'pending', 'resolved', 'rejected'])
    .isRequired,
  onClose: PropTypes.func.isRequired,
  withConfirmation: PropTypes.bool,
  onConfirm: PropTypes.func,
  clientId: PropTypes.any,
};

export default UrlFinderModal;
